/***
 * 创建人：段锐
 * 时间：2019-06-10
 * 描述：两字段重复性验证
 * 更新记录: 
 */
import { Directive, Input, forwardRef, Attribute } from "@angular/core"
import { Validator, AbstractControl,  NG_VALIDATORS, NgModel} from "@angular/forms"

@Directive({
  selector:"[validateEqual][ngModel]",
  providers:[
    {
      provide:NG_VALIDATORS,
      useExisting:forwardRef(()=>ValidatorRepeatDirective) ,
      multi:true}]
})
export class ValidatorRepeatDirective implements Validator{

  //输入属性,用来传递model
  @Input('validateEqual')
  repeat:any;

  //属性reverse用来传值,判断当前是密码框还是确认密码框
  constructor(@Attribute('reverse') public reverse:string){

  }

  //校验器实现方法
  validate(control:AbstractControl):{[property:string]:string}{
    //获取到传入的model的controll
      let e=this.repeat.control;
      //获取到传入的model的value
      let psd_1=this.repeat.value;
      //当前control的value
      let psd_2=control.value;

      //因为第一次进来会加载,如果输入值不为null则进逻辑判断
    if (psd_1 || psd_2) {      

      if(psd_1===psd_2){
        //值相等
        if(this.reverse=="true"){
          //说明是密码框触发的校验事件,则移除确认密码的错误信息
          delete e.errors['validateEqual'];
          if(!Object.keys(e.errors['validateEqual']).length) e.setErrors(null);
        }
         //说明是确认密码框触发的校验事件,则返回null
        return null
      }else{
        //值不相等
        if(this.reverse=="true"){
           //说明是密码框触发的校验事件,则添加确认密码的错误信息
         e.setErrors({validateEqual:"两次输入密码不匹配"});
         return null
        }
        //说明是确认密码框触发的校验事件,则返回不相等的信息
         return {validateEqual:"两次输入密码不匹配"}
      }
    }else{
      //第一次进来直接返回null,没有判断的必要
      return null
    }
  }
}